import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const BEGINNING_LETTER_ACTIVITY_FRAGMENT = gql `
  fragment BeginningLetterActivityFragment on BeginningLetterActivity {
    targetKey
    rounds {
      answer
      answerAudio {
        id
        audio {
          ...AssetFragment
        }
      }
      answerImage {
        id
        image {
          ...AssetFragment
        }
      }
      id
      letter
      startMinimized
    }
  }
  ${ASSET_FRAGMENT}
`;
export default BEGINNING_LETTER_ACTIVITY_FRAGMENT;
